module.exports = __webpack_public_path__ + "static/img/KANE-McAULIFFE.884d0bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KANE-McAULIFFE.jpg
// module id = RBvO
// module chunks = 0